import { render, staticRenderFns } from "./InvoiceTypeSetupForm.vue?vue&type=template&id=4d8216e9&scoped=true&"
import script from "./InvoiceTypeSetupForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceTypeSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8216e9",
  null
  
)

export default component.exports